'use client';

import React from 'react';
import { FontAwesomeIcon as Icon } from '@fortawesome/react-fontawesome';
import { faCircleCheck } from '@fortawesome/pro-solid-svg-icons';
import { PulseButton } from 'src/components/PulseUI/PulseButton';

export interface RouteCompleteBannerProps {
  onRestart: () => void;
}

const RouteCompleteBanner: React.FC<RouteCompleteBannerProps> = ({
  onRestart,
}) => (
  <div
    className="flex items-center justify-between px-4 py-3 bg-green-600 shadow-md"
    data-testid="route-complete-banner"
  >
    <div className="flex items-center gap-2 text-white">
      <Icon icon={faCircleCheck} />
      <span className="text-sm font-semibold">Route Complete</span>
    </div>
    <PulseButton
      variant="solid"
      color="neutral"
      size="sm"
      className="rounded-full bg-white"
      onClick={onRestart}
      data-testid="route-complete-restart-button"
    >
      Restart Route
    </PulseButton>
  </div>
);

export default RouteCompleteBanner;
